import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import AudioBtn from './views/AudioBtn'
import routes from './routes';
import AppContext from './AppContext';
import './Main.css';
import { Transition } from "react-router-simple-transition";
import Ratio from 'react-ratio';
import constant from './assets/const.json';

class Main extends React.Component {

    static contextType = AppContext;
    backgroundMusic = './sounds/background_music.mp3';

    goBackPage() {
        const { goBack } = this.context;
        if (goBack) {
            this.props.history.goBack();
        }
    }

    render() {
        return (
            <div className='app'>
                <Ratio ratio={ constant.DESIRED_RATIO_WIDTH / constant.DESIRED_RATIO_HEIGHT } ratioClassName='custom-ratio-content' id={'app'}>
                    <Switch>
                        {
                            routes.map((r, i) => {
                                return r.Component ? 
                                (<Route 
                                    key={r.name} 
                                    exact={r.exact} 
                                    path={r.path}
                                    loc={r.loc}
                                    render={p => <Transition><r.Component {...p}/></Transition>}>
                                </Route>) : null
                            })
                        }
                    </Switch>
                    <AudioBtn></AudioBtn>
                </Ratio>
            </div>
        );
    };
}

export default withRouter(Main);